const order = () => {

    const reloadSummary = (wrap, summary, list, info) => {
        wrap.classList.add("loading");
        fetch("/shop/cart/fragment", {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.html) {
                    if (data.html.summary || data.html.summary === "") summary.innerHTML = data.html.summary;
                    if (data.html.list || data.html.list === "") list.innerHTML = data.html.list;
                    if (data.html.info || data.html.info === "") info.innerHTML = data.html.info;
                    wrap.classList.remove("loading");
                }
            })
            .catch(err => {
                console.log(err);
            })
    }
    const getOffsetTop = (element) => {
        let top = 0;
        do {
            top += element.offsetTop  || 0;
            element = element.offsetParent;
        }
        while(element);

        return top;
    };
    const orderForm = document.querySelector("form[name='create_order_form']");
    const anotherAddressCheckbox = document.getElementById("create_order_form_addressInvoice_add");
    const version = document.querySelector(".order__version");
    const orderWrapperRight = document.querySelector(".order__wrapper.right");
    const orderList = document.querySelector("[data-summary='list']");
    const orderSummary = document.querySelector("[data-summary='summary']");
    const paymentMethod = document.querySelector(".order__form-payment-method");
    const deliveryWrap = document.querySelector(".order__delivery");
    const subscriptionWrap = document.querySelector(".order__subscription-wrap");
    const infoWrap = document.querySelector(".order__summary-info");
    const body = document.querySelector("body");
    const counter = {
        value: 0,
    }
    const counterProxy = new Proxy(counter, {
        set: function(target, key, value) {
            target[key] = value;
            if(target[key] === 0) {
                reloadSummary(orderWrapperRight, orderSummary, orderList, infoWrap);
            }
            return true;
        }
    });

    if (version) {
        const versions = version.children;
        version.addEventListener("click", function(e){
            if (!this.classList.contains("loading") && e.target.dataset.hasOwnProperty("version") && !e.target.classList.contains("active")) {
                e.preventDefault();
                counterProxy.value += 1;
                this.classList.add("loading");
                orderWrapperRight.classList.add("loading");
                for (let i = 0; i < versions.length; i++) {
                    versions[i].classList.remove("active");
                }
                e.target.classList.add("active");

                const url = e.target.dataset.add;
                const init = {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                }
                fetch(url, init)
                    .then(res => res.json())
                    .then(data => {
                        if (data.status.toLowerCase() === "ok") {
                            counterProxy.value -= 1;
                            this.classList.remove("loading");
                        }
                        else {
                            console.log(data)
                        }
                    })
                    .catch(err => {
                        counterProxy.value -= 1;
                        this.classList.remove("loading");
                        console.log(err);
                    });
            }
        });
    }

    const allOrderInputs = document.querySelectorAll('.order__form-input input, .order__form-input textarea');
    if(allOrderInputs) {
        for(let i = 0; i < allOrderInputs.length; i++) {
            if(allOrderInputs[i].value.length > 0) {
                allOrderInputs[i].classList.add('active');
            } else {
                allOrderInputs[i].classList.remove('active');
            }
            allOrderInputs[i].addEventListener('change',function() {
                if(this.value.length > 0) {
                    this.classList.add('active');
                } else {
                    this.classList.remove('active');
                }
            })
        }
    }

    const allCheckbox = document.querySelector('.order__form-checkbox.grey input');
    const bottomCheckboxes = document.querySelectorAll('.order__form-checkbox.bottom input');
    const bonusInput = document.getElementById("create_order_form_bonus_2");

    if (bonusInput) {
        bonusInput.checked ? orderWrapperRight.classList.remove("bonus-active") : orderWrapperRight.classList.add("bonus-active");
    }

    if(allCheckbox) {
        orderForm.addEventListener("change", function(e) {
            const arr = [];
            for (let i = 0; i < bottomCheckboxes.length; i++) {
                if (!arr.includes(bottomCheckboxes[i].checked)) {
                    arr.push(bottomCheckboxes[i].checked);
                }
            }
            allCheckbox.checked = arr.length === 1 && arr[0];
            bonusInput.checked ? orderWrapperRight.classList.remove("bonus-active") : orderWrapperRight.classList.add("bonus-active");
        });
        allCheckbox.addEventListener('change',function () {
            for(let i = 0; i < bottomCheckboxes.length; i++) {
                bottomCheckboxes[i].checked = this.checked;
            }
        })
    }

    function validateRadio(item) {
        const inputs = item.querySelectorAll("input");
        let checked = false;
        for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].checked) checked = true;
        }
        checked ? item.classList.remove("error") : item.classList.add("error");
        return checked;
    }
    function validateText(item) {
        const input = item.querySelector("input");
        const error = item.querySelector(".order__form-error");
        let required = input.required;
        if (anotherAddressCheckbox.checked) {
            required = input.required || input.dataset.hasOwnProperty("validate");
        }
        let validate = !(input.value.trim() === "" && required);

        if (required && input.name.indexOf("email") !== -1 && input.value.trim() !== "") {
            const checkMail = new RegExp(/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/);
            validate = checkMail.test(input.value.trim());
            if (!validate) {
                error.innerText = "Podaj prawidłowy adres email";
            }
        }
        if (required && input.name.indexOf("phone") !== -1 && input.value.trim() !== "") {
            const checkPhone = new RegExp(/^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/);
            validate = checkPhone.test(input.value.trim());
            if (!validate) {
                error.innerText = "Podaj prawidłowy nr telefonu";
            }
        }
        if (required && input.name.indexOf("zip") !== -1 && input.value.trim() !== "") {
            const checkZipCode = new RegExp(/^[0-9]{2}-[0-9]{3}/);
            validate = checkZipCode.test(input.value.trim());
            if (!validate) {
                error.innerText = "Podaj prawidłowy kod pocztowy (00-000)";
            }
        }

        if (required && input.name.indexOf("nip") !== -1 && input.value.trim() !== "") {
            let nip = input.value.trim();
            let weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
            nip = nip.replace(/[\s-]/g, '');

            if (nip.length === 10 && parseInt(nip, 10) > 0) {
                let sum = 0;
                for(let i = 0; i < 9; i++){
                    sum += nip[i] * weights[i];
                }
                validate = (sum % 11) === Number(nip[9]);
            }
            else {
                validate = false;
            }

            if (!validate) {
                error.innerText = "Podaj prawidłowy nr NIP";
            }
        }

        validate ? item.classList.remove("error") : item.classList.add("error");
        return validate;
    }
    function validateCheckbox(item) {
        const input = item.querySelector("input");
        let validate = true;
        if (input.required) {
            validate = input.checked;
            validate ? item.classList.remove("error") : item.classList.add("error");
        }
        return validate;
    }

    if (orderForm) {
        const anotherAddress = document.getElementsByClassName("order__another-address")[0];

        if (anotherAddressCheckbox) {
            anotherAddressCheckbox.checked ? anotherAddress.classList.add("open") : anotherAddress.classList.remove("open");
            anotherAddressCheckbox.addEventListener("change", function() {
                this.checked ? anotherAddress.classList.add("open") : anotherAddress.classList.remove("open");
            });
        }
        const comment = document.getElementById("comment");
        const commentWrap = document.getElementsByClassName("order__comment-wrapper")[0];
        if (comment) {
            comment.checked ? commentWrap.classList.add("open") : commentWrap.classList.remove("open");
            comment.addEventListener("change", function () {
                this.checked ? commentWrap.classList.add("open") : commentWrap.classList.remove("open");
            });

        }
        orderForm.addEventListener("submit", function(e) {
            e.preventDefault();
            let validate = true;

            const paczkomaty24 = document.querySelector(".order__delivery-item.active[data-delivery='paczkomaty-24']");
            if (paczkomaty24 && (!paczkomaty24.classList.contains("selected") || document.querySelector("[name='create_order_form[deliveryParameters][targetPoint]']").value.trim() === "")) {
                paczkomaty24.closest(".order__delivery").classList.add("error--selected");
                paczkomaty24.closest(".order__delivery").classList.add("error");
                validate = false;
            }

            const textInputs = e.target.querySelectorAll(".order__form-input");
            if (textInputs) {
                for (let i = 0; i < textInputs.length; i++) {
                    if (!validateText(textInputs[i])) validate = false;
                }
            }
            const checkboxInputs = e.target.querySelectorAll(".order__form-checkbox");
            if (checkboxInputs) {
                for (let i = 0; i < checkboxInputs.length; i++) {
                    if (!validateCheckbox(checkboxInputs[i])) validate = false;
                }
            }

            // Active payment
            if (!document.querySelector(".active[data-payment][data-id]")) {
                paymentMethod.classList.add("error");
                validate = false;
            }
            else {
                paymentMethod.classList.remove("error");
            }

            // Active delivery
            if (!document.querySelector(".active[data-delivery][data-id]")) {
                deliveryWrap.classList.add("error");
                validate = false;
            }
            else {
                deliveryWrap.classList.remove("error");
            }

            // Active Subscription
            if (!subscriptionWrap.querySelector("input[type='radio']:checked")) {
                subscriptionWrap.classList.add("error");
                validate = false;
            }
            else {
                subscriptionWrap.classList.remove("error");
            }

            if (validate) {
                let formData = new FormData(this);
                body.classList.add("loading");
                fetch(this.action, {
                    method: "POST",
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data.valid) {
                            window.location.href = data.redirectUrl;
                        }
                        else {
                            console.log(data)
                            for (let error in data.errors.fields) {
                                if (data.errors.fields.hasOwnProperty(error)) {
                                    const input = document.getElementById(`${error}`);
                                    const parent = input.parentElement;
                                    const errorEl = parent.querySelector(".order__form-error");
                                    parent.classList.add("error");
                                    errorEl.innerText = data.errors.fields[`${error}`];
                                    const firstErr = document.querySelector(".error, .error--selected");
                                    window.scrollTo(0, getOffsetTop(firstErr));
                                }
                            }
                        }
                        body.classList.remove("loading");
                    })
                    .catch(err => {
                        body.classList.add("loading");
                        console.log(err)
                    });
            }
            else {
                const firstErr = document.querySelector(".error, .error--selected");
                window.scrollTo(0, getOffsetTop(firstErr));
            }
        });
    }

    // Additions
    const additions = document.querySelectorAll("[data-addition]");
    if (additions.length > 0) {
        for (let i = 0; i < additions.length; i++) {
            additions[i].addEventListener("click", function(e){
                e.preventDefault();
                if (this.classList.contains("loading")) return;
                orderWrapperRight.classList.add("loading");
                this.classList.add("loading");
                counterProxy.value += 1;
                const url = this.dataset.basket === "false" ? this.dataset.add : this.dataset.remove;
                const init = {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                }
                fetch(url, init)
                    .then(res => res.json())
                    .then(data => {
                        if (data.status.toLowerCase() === "ok") {
                            this.dataset.basket === "true" ? this.dataset.basket = "false" : this.dataset.basket = "true";
                            this.classList.remove("loading");

                            const checkPaymentBefore = document.querySelector(".active[data-payment][data-id]");
                            fetch("/shop/cart/payment-method-fragment")
                                .then(res => res.text())
                                .then(res => {
                                    counterProxy.value -= 1;
                                    if (paymentMethods) paymentMethods.innerHTML = res;

                                    const checkPaymentAfter = document.querySelector(".active[data-payment][data-id]");

                                    if (checkPaymentBefore && !checkPaymentAfter) {
                                        paymentMethod.classList.add("not-available");
                                    }
                                    else if (!checkPaymentBefore && !checkPaymentAfter) {
                                        paymentMethod.classList.remove("not-available");
                                    }
                                })
                                .catch(err => {
                                    counterProxy.value -= 1;
                                    this.classList.remove("loading");
                                    e.target.classList.remove("loading");
                                    console.log(err);
                                })
                        }
                    })
                    .catch(err => {
                        this.classList.remove("loading");
                        console.log(err);
                    });
            });
        }
    }


    // Delivery
    const deliveryMethods = document.querySelector(".order__methods--delivery");
    const paymentMethods = document.querySelector(".order__form-payment-method-list");

    if (deliveryMethods) {
        deliveryMethods.addEventListener("click", function(e){
            e.preventDefault();
            if (this.classList.contains("loading") || e.target.classList.contains("active")) return;
            if (e.target.dataset.hasOwnProperty("delivery")) {
                e.target.classList.add("loading");
                const deliveryMethodId = e.target.dataset.id;
                const url = `/shop/cart/delivery-method/${deliveryMethodId}`;

                orderWrapperRight.classList.add("loading");
                this.classList.add("loading");

                counterProxy.value += 1;

                const checkPaymentBefore = document.querySelector(".active[data-payment][data-id]");

                fetch(url, {
                    method: "POST",
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                })
                    .then(res => res.json())
                    .then(res => {
                        if (res.status === "success") {
                            fetch("/shop/cart/payment-method-fragment")
                                .then(res => res.text())
                                .then(res => {
                                    counterProxy.value -= 1;
                                    if (paymentMethods) paymentMethods.innerHTML = res;
                                    this.classList.remove("loading");
                                    e.target.classList.remove("loading");
                                    paymentMethod.classList.remove("inactive");

                                    const deliveryPointInput = document.querySelector("input[data-delivery='point']");
                                    if (deliveryPointInput) deliveryPointInput.value = "";

                                    const checkActive = document.querySelector(".order__delivery .order__delivery-item.active");
                                    if (checkActive) checkActive.classList.remove("active");

                                    const checkSelected = document.querySelector(".order__delivery .order__delivery-item.selected");
                                    if (checkSelected) checkSelected.classList.remove("selected");

                                    const checkPaymentAfter = document.querySelector(".active[data-payment][data-id]");

                                    if (checkPaymentBefore && !checkPaymentAfter) {
                                        paymentMethod.classList.add("not-available");
                                    }
                                    else if (!checkPaymentBefore && !checkPaymentAfter) {
                                        paymentMethod.classList.remove("not-available");
                                    }

                                    e.target.classList.add("active");
                                })
                                .catch(err => {
                                    counterProxy.value -= 1;
                                    this.classList.remove("loading");
                                    e.target.classList.remove("loading");
                                    console.log(err);
                                })
                        }
                        else {
                            this.classList.remove("loading");
                            e.target.classList.remove("loading");
                            counterProxy.value -= 1;
                        }
                    })
                    .catch(err => {
                        counterProxy.value -= 1;
                        console.log(err);
                    })
            }
        });
    }

    if (paymentMethods) {
        paymentMethods.addEventListener("click", function(e){
            e.preventDefault();
            if (this.classList.contains("loading") || this.classList.contains("inactive") || e.target.classList.contains("active")) return;
            if (e.target.dataset.hasOwnProperty("payment") && !e.target.classList.contains("inactive")) {
                const paymentMethodId = e.target.dataset.id;
                const url = `/shop/cart/payment-method/${paymentMethodId}`;
                orderWrapperRight.classList.add("loading");
                e.target.classList.add("loading");
                this.classList.add("loading");
                counterProxy.value += 1;
                fetch(url, {
                    method: "POST",
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                })
                    .then(res => res.json())
                    .then(res => {
                        if (res.status === "success") {
                            fetch("/shop/cart/payment-method-fragment")
                                .then(res => res.text())
                                .then(res => {
                                    counterProxy.value -= 1;
                                    this.classList.remove("loading");
                                    paymentMethod.classList.remove("not-available");
                                    e.target.classList.remove("loading");
                                    const checkActive = document.querySelector(".order__form-payment-method-list .order__delivery-item.active")
                                    if (checkActive) {
                                        checkActive.classList.remove("active");
                                    }
                                    e.target.classList.add("active");
                                })
                                .catch(err => {
                                    counterProxy.value -= 1;
                                    this.classList.remove("loading");
                                    e.target.classList.remove("loading");
                                    console.log(err);
                                })
                        }
                        else {
                            counterProxy.value -= 1;
                            this.classList.remove("loading");
                            e.target.classList.remove("loading");
                        }
                    })
                    .catch(err => {
                        counterProxy.value -= 1;
                        this.classList.remove("loading");
                        e.target.classList.remove("loading");
                        console.log(err);
                    })
            }
        });
    }

    const toggleDescription = document.querySelector(".js-description-toggle");
    if (toggleDescription) {
        toggleDescription.addEventListener("click", function() {
            this.parentElement.classList.toggle("open");
        });
    }

    const toggleWidgetBtns = document.querySelectorAll(".order__delivery-item-btn[data-widget]");
    for (let i = 0; i < toggleWidgetBtns.length; i++) {
        const element = document.querySelector(`.order__delivery-widget[data-widget='${toggleWidgetBtns[i].dataset.widget}']`);
        element.addEventListener("click", function(e){
            if (e.target.dataset.hasOwnProperty("widget")) {
                this.classList.remove("open");
            }
            if (e.target.classList.contains("order__delivery-widget-close")) {
                this.classList.remove("open");
            }
        });
        toggleWidgetBtns[i].addEventListener("click", function (){
            if (element) {
                element.classList.add("open");
            }
        });
    }
};

export default order;